import { AdminLinkButton, type AdminLinkButtonProps } from "@/admin/AdminLinkButton.tsx";
import { Missing } from "@/admin/AdminTable.tsx";
import { adminUserLink } from "@/admin/itemLinks.ts";

export function UserLink({
    value,
    label,
}: {
    value: string | number | null | undefined;
    label?: AdminLinkButtonProps["label"];
}) {
    if (value == null) {
        return <Missing />;
    }

    return <AdminLinkButton action={adminUserLink(String(value))} label={label ?? value} />;
}
